export function montaQuery(params: string): string {
    let valor = ''
    valor = params === '' ? '&Condition=' : ' and '
    return valor
}  